import { render, staticRenderFns } from "./ErrorPage.vue?vue&type=template&id=70115a70&scoped=true"
import script from "./ErrorPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ErrorPage.vue?vue&type=style&index=0&id=70115a70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70115a70",
  null
  
)

export default component.exports